import apiClient from '@/services/axios'
import utilities from '@/services/utilities'

export async function getTickets(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/pos/tickets', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function getOneTicket(id) {
	return new Promise((resolve, reject) => {
		return apiClient
			.get(`/pos/ticket/${id}`)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function requestAuthorization(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post(`/pos/request-authorization`, payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function closeAdvanceTicket(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.put(`/pos/close-advance`, payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function getPDFReport(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post(`/reports/sales`, payload)
			.then((response) => {
				// console.log('response-->', response)
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function createBill(payload) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/billing/create', payload)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function downloadBill(facturamaId) {
	return new Promise((resolve, reject) => {
		return apiClient
			.get(`/billing/download/${facturamaId}`)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function sendBillEmail(facturamaId) {
	return new Promise((resolve, reject) => {
		return apiClient
			.get(`/billing/send-email/${facturamaId}`)
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}

export async function refactorBill(id) {
	return new Promise((resolve, reject) => {
		return apiClient
			.post('/billing/refactor', { id })
			.then((response) => {
				resolve(utilities.objectValidate(response, 'data', {}))
			})
			.catch((err) => {
				console.log(err)
				reject(err)
			})
	})
}
